import { createStyles } from "@mantine/emotion";

export const useStylesLoader = createStyles((theme) => ({
  loader: {
    width: "100%",
    paddingTop: "0",
    paddingBottom: "0",
    position: "fixed",
    maxWidth: "none",
    marginTop: "0",
    maxHeight: "none",
    minHeight: "0",
    height: "100%",
    top: "0",
    left: "0",
    display: "flex",
    backgroundColor: "rgba(0,0,0,0.5)",
    flexWrap: "wrap",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    zIndex: "10",
    ".block": {
      backgroundColor: theme.customBackgrounds.white,
      padding: theme.spacing.loader.block.padding,
      width: theme.spacing.loader.block.width,
      maxWidth: "100%",
      textAlign: "center",
    },
    ".animation": {
      display: "block",
      width: theme.spacing.loader.animation.width,
      height: theme.spacing.loader.animation.height,
      border: `${theme.spacing.loader.animation.borderWidth} solid ${theme.customColors.animationLoader}`,
      borderTop: `${theme.spacing.loader.animation.borderWidth} solid ${theme.customColors.black}`,
      borderRadius: "50%",
      position: "absolute",
    },
    ".text-1": {
      fontSize: theme.spacing.loader.text.primary.fontSize,
    },
    ".text-2": {
      fontSize: theme.spacing.loader.text.secondary.fontSize,
      fontFamily: theme.headings.fontFamily.light,
      marginTop: theme.spacing.loader.text.secondary.marginTop,
      textAlign: "center",
    },
  },
  bg: {
    width: "100%",
    height: "100%",
    backgroundColor: theme.customBackgrounds.bg,
    position: "fixed",
    bottom: "0",
    top: "0",
    left: "0",
    right: "0",
    zIndex: "9",
  },
}));
